import cx from "classnames";
import { History } from "history";
import React from "react";

import { bazaarUrl } from "@/mk2/apps/bazaar/urls";
import BazaarSearch from "@/mk2/apps/home/components/BazaarSearch";
import { BluePill } from "@/mk2/apps/home/components/BluePill";
import { HomePageState } from "@/mk2/apps/home/containers/Home/Home.reducers";
import { homepageUrl } from "@/mk2/apps/home/urls";
import { settingsLocationUrl } from "@/mk2/apps/settings/urls";
import { signupUrl } from "@/mk2/apps/users/urls";
import { Interpolate } from "@/mk2/components/Interpolate";
import { Link } from "@/mk2/components/Link";
import { LoadingPlaceholder } from "@/mk2/components/LoadingPlaceholder";
import { url } from "@/mk2/helpers/urls";
import { UserEntity } from "@/mk2/schemas";
import {
    index as categoriesIndex,
    prams_and_accessories as pramsAndAccessoriesCategory,
} from "@/mk/autogenerated/bzCategories";
import {
    BZ2_CAT_CLOTHING,
    BZ2_CAT_FOOTWEAR,
    BZ2_CAT_HOME_LIVING,
    BZ2_CAT_PRAMS,
    BZ2_CAT_TOYS,
    HOMEPAGE_MORE_CATEGORIES,
    HOMEPAGE_MORE_CATEGORIES_SHORT,
    HOME_SHOW_PRODUCTS_FROM_YOUR_LOCATION,
    HOME_SHOW_PRODUCTS_FROM_location,
} from "@/mk/autogenerated/translation";
import { isAuthenticated } from "@/mk/bazaar/common/userUtils";
import { getCountyName } from "@/mk/geo";
import { bazaar_single_page_product_grid_category_url } from "@/mk/urls/functions";

import styles from "./Bazaar2.mscss";

const pramsCategory = pramsAndAccessoriesCategory.find((c) => c.name === "prams");
const footwearCategory = categoriesIndex.find((c) => c.name === "footwear");
const toysCategory = categoriesIndex.find((c) => c.name === "toys");
const clothingCategory = categoriesIndex.find((c) => c.name === "clothing");
const homeLivingCategory = categoriesIndex.find((c) => c.name === "home_living");

interface OwnProps {
    className?: string;

    prams: number;
    footwear: number;
    toys: number;
    others: number;
    history?: History;
    isMobile: boolean;
    places: Record<number, number>;
    place: HomePageState["place"];
    requestUser: UserEntity;
}

type Props = OwnProps;

class Bazaar2 extends React.PureComponent<Props> {
    public render() {
        const {
            className,
            isMobile,
            // toys, footwear, prams, others,
            place,
            places,
            requestUser,
            history,
        } = this.props;

        return (
            <div className={cx(styles.Bazaar2, className)}>
                <BazaarSearch history={history} />

                <div className={styles.Bazaar2__categories}>
                    <BluePill
                        className={styles.Bazaar2__category}
                        to={bazaar_single_page_product_grid_category_url(pramsCategory.slug)}
                        label={BZ2_CAT_PRAMS}
                    />
                    <BluePill
                        className={styles.Bazaar2__category}
                        to={bazaar_single_page_product_grid_category_url(footwearCategory.slug)}
                        label={BZ2_CAT_FOOTWEAR}
                    />
                    <BluePill
                        className={styles.Bazaar2__category}
                        to={bazaar_single_page_product_grid_category_url(toysCategory.slug)}
                        label={BZ2_CAT_TOYS}
                    />
                    <BluePill
                        className={styles.Bazaar2__category}
                        to={bazaar_single_page_product_grid_category_url(clothingCategory.slug)}
                        label={BZ2_CAT_CLOTHING}
                    />
                    {place?.countyId &&
                        places[place?.id] && ( // Places without countyId cannot be set in facets
                            <BluePill
                                className={styles.Bazaar2__category}
                                to={url(
                                    bazaarUrl,
                                    {},
                                    {
                                        places: place.id,
                                        locations: getCountyName(place.countyId),
                                    },
                                )}
                                label={
                                    <span className={styles.Bazaar2__fontWeightNormal}>
                                        <Interpolate
                                            i18nKey={HOME_SHOW_PRODUCTS_FROM_location}
                                            location={<strong>{place.name}</strong>}
                                        />
                                    </span>
                                }
                            />
                        )}
                    <BluePill
                        className={styles.Bazaar2__category}
                        to={url(bazaarUrl, {}, isMobile ? { opened: "cats" } : {})}
                        label={HOMEPAGE_MORE_CATEGORIES_SHORT}
                    />
                </div>
            </div>
        );
    }
}

export default Bazaar2;

interface PlaceholderOwnProps {
    className?: string;
    history?: History;
    isMobile: boolean;
}

let Bazaar2Placeholder: React.FunctionComponent<PlaceholderOwnProps> = ({
    className,
    history,
    isMobile,
}) => (
    <div className={cx(styles.Bazaar2, className)}>
        <BazaarSearch history={history} />

        <div className={styles.Bazaar2__categories}>
            <BluePill
                className={styles.Bazaar2__category}
                to={bazaar_single_page_product_grid_category_url(pramsCategory.slug)}
                label={BZ2_CAT_PRAMS}
            />
            <BluePill
                className={styles.Bazaar2__category}
                to={bazaar_single_page_product_grid_category_url(footwearCategory.slug)}
                label={BZ2_CAT_FOOTWEAR}
            />
            <BluePill
                className={styles.Bazaar2__category}
                to={bazaar_single_page_product_grid_category_url(toysCategory.slug)}
                label={BZ2_CAT_TOYS}
            />
            <BluePill
                className={styles.Bazaar2__category}
                to={url(bazaarUrl, {}, isMobile ? { opened: "cats" } : {})}
                label={BZ2_CAT_CLOTHING}
            />
        </div>

        <div className={styles.Bazaar2__placeCount}>
            <LoadingPlaceholder width={300} height={34} />
        </div>
    </div>
);

Bazaar2Placeholder.displayName = "Bazaar2Placeholder";
Bazaar2Placeholder = React.memo<PlaceholderOwnProps>(Bazaar2Placeholder);

export { Bazaar2Placeholder };
